export default "__VITE_ASSET__51f890aa__"